import _sfc_main from './sound-event-content.vue2.js';
/* empty css                        */
import _export_sfc from '../../../_virtual/_plugin-vue_export-helper.js';

const SoundContent = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-1ab2e031"]]);

export { SoundContent as default };
//# sourceMappingURL=sound-event-content.js.map
